import { NextRouter } from "next/router";
import { Dispatch, SetStateAction } from "react";
import { createOverlayInfo } from "./OverlayInfo";
import { createOverlayPDF } from "./OverlayPDF";
import { createOverlayAdReward } from "./OverlayAdReward";
import { VIEW_FROM } from "@/config/enums";

export type OverlayType = "VIDEO" | "PDF" | "INFO" | "AD_REWARD";

export interface IOverlay {
  playerRef: any;
  state?: number;
  setState?: Dispatch<SetStateAction<number>>;
  overlayType: OverlayType;
  className?: string;
  params?: any;
  start: number | string;
  end: number | string;
}

export function getOverlayButtonOptions(playerRef: any, playPlayer: () => void, router: NextRouter, playlist?: { previousUrl?: string; nextUrl?: string }) {
  const options: any = {
    seekLeft: {
      handleClick: () => {
        const time = Number(playerRef.currentTime()) - 10;
        playerRef.currentTime(time);
      },
      doubleTap: true,
    },
    play: {
      handleClick: () => {
        if (playerRef.paused()) {
          playPlayer();
        } else {
          playerRef.pause();
        }
      },
    },
    seekRight: {
      handleClick: () => {
        const time = Number(playerRef.currentTime()) + 10;
        playerRef.currentTime(time);
      },
      doubleTap: true,
    },
    lockButton: false
  };
  return {
    previous: {
      handleClick: () => {
        if (!playlist?.previousUrl) {
          return;
        }
        router.push(`${playlist?.previousUrl}` as string);
      },
      disabled: !playlist?.previousUrl,
    },
    ...options,
    next: {
      handleClick: () => {
        if (!playlist?.nextUrl) {
          return;
        }
        router.push(`${playlist?.nextUrl}` as string);
      },
      disabled: !playlist?.nextUrl,
    },
  };
}

export function getOverlayOptions(videoDuration: number | undefined, overlayOptions: IOverlay[] | undefined) {
  if (!videoDuration || !overlayOptions) {
    return {
      overlays: [],
    };
  }

  const overlays = [];
  for (let i = 0; i < overlayOptions.length; i++) {
    const overlayOption = overlayOptions[i];
    const start = typeof overlayOption.start === "string" ? overlayOption.start.replace(/ /g, "") : overlayOption.start;
    const end = typeof overlayOption.end === "string" ? overlayOption.end.replace(/ /g, "") : overlayOption.end;
    switch (overlayOption.overlayType) {
      case "INFO":
        overlays.push({
          start,
          end,
          showBackground: false,
          class: `flex justify-center text-sm !left-0 !z-auto !max-w-full !w-full h-max ${overlayOption.params?.position?.startsWith("T") ? "" : "!relative"}`,
          content: createOverlayInfo(i, overlayOption.playerRef, overlayOption.setState, overlayOption.params),
        });
        break;
      case "PDF":
        overlays.push({
          start,
          end,
          showBackground: false,
          class: `flex justify-center text-sm !left-0 !z-auto !max-w-full !w-full h-max !relative`,
          content: createOverlayPDF(i, overlayOption.playerRef, overlayOption.setState, overlayOption.params),
        });
        break;
      case "AD_REWARD":
        overlays.push({
          start,
          end,
          showBackground: false,
          class: `flex justify-center text-sm !left-0 !z-auto !max-w-full !w-full h-max !relative`,
          content: createOverlayAdReward(i, overlayOption.playerRef, overlayOption.setState, overlayOption.params),
        });
        break;
      default:
        break;
    }
  }

  return { overlays };

  // const nextVideoProgress = [5, 4, 3, 2, 1, 0].map((x) => ({
  //   start: duration - x,
  //   end: duration - x + 1,
  //   showBackground: false,
  //   class: "flex justify-center text-sm !left-0 !z-auto !max-w-full !w-full",
  //   content: renderToString(<OverlayNextVideo duration={x} />)
  // }))

  // return {
  //   overlays: [{
  //     start: duration - 10,
  //     showBackground: false,
  //     class: "text-black flex justify-center items-end text-sm !left-0 !z-auto !max-w-full !w-full",
  //     content: renderToString(<OverlayVideos resources={resources} />)
  //   }, ...nextVideoProgress],
  // }
}

export interface IDownloadAppOverlay { 
  classType: string| number; 
  href: string; 
  title: string;
  bottomTitle: string;
  innerHTML: string;
  src: string;
  sectionImgSrc: string;
  ratingSrc?: string;
  buttonText?: string
}
